import { datadogLogs } from '@datadog/browser-logs';

import { nvPartners } from './client';

export async function updateEnabledRecommendation(
  enableRecommendation: boolean,
) {
  try {
    return await nvPartners.patch(
      '/v1/partners/enable-recommendation',
      JSON.stringify(enableRecommendation),
    );
  } catch (error) {
    datadogLogs.logger.error(
      'Error while fetching updating enable recommendation',
      {
        error,
      },
    );

    throw new Error(
      `Error while updating enable recommendation of partner: ${JSON.stringify(
        error,
        null,
        2,
      )}`,
    );
  }
}

export async function savePartnerPreferredLanguage() {
  return nvPartners.patch(`/v1/partners`, {
    preferred_language: navigator.language,
  });
}
